import React, { useState } from 'react';

const RevenueEstimator = () => {
    const [views, setViews] = useState(100000);
    const [category, setCategory] = useState('Tech & Gadgets');
    const [region, setRegion] = useState('GLOBAL');
    const [monetizedRatio, setMonetizedRatio] = useState(0.60);
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState('');

    const handleCalculate = async (e) => {
        if (e) e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const token = localStorage.getItem('token');
            const response = await fetch('/api/analysis/revenue-estimator', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ views, category, region, monetizedRatio })
            });

            const data = await response.json();
            if (!response.ok || !data.success) {
                throw new Error(data.message || 'Failed to estimate revenue.');
            }
            setResult(data.data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '2rem 1rem', color: '#f8fafc' }}>
            <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
                <div style={{ 
                    display: 'inline-block', 
                    padding: '0.4rem 1rem', 
                    background: 'rgba(234, 179, 8, 0.15)', 
                    border: '1px solid rgba(234, 179, 8, 0.3)', 
                    borderRadius: '20px', 
                    fontSize: '0.85rem', 
                    color: '#eab308',
                    marginBottom: '0.8rem',
                    fontWeight: 600
                }}>
                    💰 Phase 2 Differentiation Feature (10 Credits)
                </div>
                <h1 style={{ 
                    fontSize: '2.5rem', 
                    fontWeight: 800, 
                    background: 'linear-gradient(135deg, #eab308, #f59e0b, #3b82f6)', 
                    WebkitBackgroundClip: 'text', 
                    WebkitTextFillColor: 'transparent',
                    marginBottom: '0.5rem'
                }}>
                    Revenue & CPM Estimator
                </h1>
                <p style={{ color: '#94a3b8', fontSize: '1.05rem', maxWidth: '650px', margin: '0 auto' }}>
                    Project AdSense Ad revenue (55% creator RPM share) and brand sponsorship rates broken down by category CPMs and regional geographic tiers.
                </p>
            </div>

            <form onSubmit={handleCalculate} style={{ 
                background: 'rgba(15, 23, 42, 0.75)', 
                backdropFilter: 'blur(16px)', 
                border: '1px solid rgba(255, 255, 255, 0.1)', 
                borderRadius: '16px', 
                padding: '1.8rem', 
                marginBottom: '2rem',
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
                gap: '1.2rem',
                alignItems: 'end'
            }}>
                <div>
                    <label style={{ fontSize: '0.85rem', color: '#94a3b8', display: 'block', marginBottom: '0.4rem' }}>
                        Expected Views: <strong style={{ color: '#f8fafc' }}>{Number(views).toLocaleString()}</strong>
                    </label>
                    <input
                        type="range"
                        min="5000"
                        max="2000000"
                        step="5000"
                        value={views}
                        onChange={(e) => setViews(e.target.value)}
                        style={{ width: '100%', accentColor: '#eab308', cursor: 'pointer' }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: '0.85rem', color: '#94a3b8', display: 'block', marginBottom: '0.4rem' }}>Content Niche / Category</label>
                    <select
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                        style={{
                            width: '100%',
                            background: 'rgba(30, 41, 59, 0.8)',
                            border: '1px solid rgba(255, 255, 255, 0.15)',
                            borderRadius: '10px',
                            padding: '0.75rem',
                            color: '#fff',
                            fontSize: '0.95rem'
                        }}
                    >
                        <option value="Tech & Gadgets">Tech & Gadgets</option>
                        <option value="Finance & Investing">Finance & Investing</option>
                        <option value="Education & Tutorials">Education & Tutorials</option>
                        <option value="Gaming">Gaming</option>
                        <option value="Entertainment & Vlogs">Entertainment & Vlogs</option>
                        <option value="Health & Fitness">Health & Fitness</option>
                        <option value="Business & Entrepreneurship">Business & Entrepreneurship</option>
                    </select>
                </div>

                <div>
                    <label style={{ fontSize: '0.85rem', color: '#94a3b8', display: 'block', marginBottom: '0.4rem' }}>Target Audience Region</label>
                    <select
                        value={region}
                        onChange={(e) => setRegion(e.target.value)}
                        style={{
                            width: '100%',
                            background: 'rgba(30, 41, 59, 0.8)',
                            border: '1px solid rgba(255, 255, 255, 0.15)',
                            borderRadius: '10px',
                            padding: '0.75rem',
                            color: '#fff',
                            fontSize: '0.95rem'
                        }}
                    >
                        <option value="US">United States (Tier 1 High CPM)</option>
                        <option value="GB">United Kingdom (Tier 1)</option>
                        <option value="CA">Canada (Tier 1)</option>
                        <option value="IN">India (High Volume Tier)</option>
                        <option value="GLOBAL">Mixed Global Audience</option>
                    </select>
                </div>

                <button
                    type="submit"
                    disabled={loading}
                    style={{
                        background: 'linear-gradient(135deg, #eab308, #ca8a04)',
                        border: 'none',
                        borderRadius: '10px',
                        padding: '0.85rem 1.5rem',
                        color: '#000',
                        fontWeight: 800,
                        fontSize: '1rem',
                        cursor: loading ? 'not-allowed' : 'pointer',
                        boxShadow: '0 4px 14px rgba(234, 179, 8, 0.4)'
                    }}
                >
                    {loading ? 'Calculating...' : 'Calculate Earnings (10 Credits)'}
                </button>
            </form>

            {error && (
                <div style={{ background: 'rgba(239, 68, 68, 0.15)', border: '1px solid rgba(239, 68, 68, 0.3)', color: '#fca5a5', padding: '1rem 1.5rem', borderRadius: '12px', marginBottom: '2rem' }}>
                    ❌ {error}
                </div>
            )}

            {result && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
                    {/* Revenue Display Cards */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '1.5rem' }}>
                        <div style={{
                            background: 'linear-gradient(135deg, rgba(30, 41, 59, 0.8), rgba(15, 23, 42, 0.9))',
                            border: '1px solid rgba(234, 179, 8, 0.3)',
                            borderRadius: '16px',
                            padding: '1.8rem',
                            textAlign: 'center'
                        }}>
                            <div style={{ fontSize: '0.85rem', color: '#94a3b8' }}>Est. Single Video AdSense</div>
                            <div style={{ fontSize: '2.5rem', fontWeight: 900, color: '#facc15', margin: '0.3rem 0' }}>
                                ${result.earnings.singleVideo.avgUSD}
                            </div>
                            <div style={{ fontSize: '0.85rem', color: '#4ade80' }}>
                                ₹{result.earnings.singleVideo.avgINR.toLocaleString()} (INR)
                            </div>
                        </div>

                        <div style={{
                            background: 'linear-gradient(135deg, rgba(30, 41, 59, 0.8), rgba(15, 23, 42, 0.9))',
                            border: '1px solid rgba(59, 130, 246, 0.3)',
                            borderRadius: '16px',
                            padding: '1.8rem',
                            textAlign: 'center'
                        }}>
                            <div style={{ fontSize: '0.85rem', color: '#94a3b8' }}>Monthly AdSense (4 uploads)</div>
                            <div style={{ fontSize: '2.5rem', fontWeight: 900, color: '#60a5fa', margin: '0.3rem 0' }}>
                                ${result.earnings.monthlyProjections.avgUSD}
                            </div>
                            <div style={{ fontSize: '0.85rem', color: '#93c5fd' }}>
                                Range: ${result.earnings.monthlyProjections.lowUSD} - ${result.earnings.monthlyProjections.highUSD}
                            </div>
                        </div>

                        <div style={{
                            background: 'linear-gradient(135deg, rgba(30, 41, 59, 0.8), rgba(15, 23, 42, 0.9))',
                            border: '1px solid rgba(168, 85, 247, 0.3)',
                            borderRadius: '16px',
                            padding: '1.8rem',
                            textAlign: 'center'
                        }}>
                            <div style={{ fontSize: '0.85rem', color: '#94a3b8' }}>Dedicated Brand Sponsorship</div>
                            <div style={{ fontSize: '1.5rem', fontWeight: 800, color: '#c084fc', margin: '0.5rem 0' }}>
                                {result.sponsorshipEstimate.dedicatedVideoUSD}
                            </div>
                            <div style={{ fontSize: '0.8rem', color: '#cbd5e1' }}>
                                Direct brand placement rate
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default RevenueEstimator;
